import { FC } from 'react';
import { IconButton } from '../iconButton';
import { MAIN_COLOR } from 'shared/consts';
import penIcon from 'assets/icons/pen-icon.svg';
import penWhiteIcon from 'assets/icons/pen-white-icon.svg';
import { IconButtonStyles } from '../iconButton/iconButton';

interface PenIconButtonProps {
	onClick: () => void;
	backgroundMain?: boolean;
	hide?: boolean;
	light?: boolean;
	disableTouch?: boolean;
  styles?: IconButtonStyles;
}

export const PenIconButton: FC<PenIconButtonProps> = ({
	onClick,
	backgroundMain = false,
	light = false,
	hide = false,
	disableTouch = false,
  styles,
}) => {
	return (
		<IconButton
			role="pen-button"
			iconSrc={light ? penWhiteIcon : penIcon}
			hide={hide}
			onClick={onClick}
			disableTouch={disableTouch}
			styles={styles || {
				background: backgroundMain ? MAIN_COLOR : 'transparent',
			}}
		/>
	);
};
